import { authRoles } from '../../../auth/authRoles'
import KardexPeriodoGestion from './view/KardexPeriodoGestion'

export const kardexPeriodoRoutesMap = {
  gestion: {
    path: '/kardexPeriodo/gestion',
    name: 'Inicio Operaciones',
  },
  registro: {
    path: '/kardexPeriodo/nuevo',
    name: 'Nuevo Kardex Período',
  },
}

const kardexPeriodoRoutes = [
  {
    path: kardexPeriodoRoutesMap.gestion.path,
    element: <KardexPeriodoGestion />,
    auth: authRoles.admin,
  },
]
export default kardexPeriodoRoutes
